import type {
  ClientListResponseDTO,
  ClientResponseDTO,
  CreateClientResponseDTO,
  RotateSecretResponseDTO,
  CreateCredentialResponse,
  CredentialItem,
  RotateSecretResponse,
} from "sandbox/types";

const credentialItemMapper = (item: ClientResponseDTO): CredentialItem => ({
  id: item.client_id,
  clientId: item.client_id,
  name: item.name,
  createdAt: item.created_at,
  lastUsedAt: item.last_active_at,
});

export const toCredentialListFromDTO = (
  dto: ClientListResponseDTO,
): CredentialItem[] => dto.clients.map(credentialItemMapper);

export const toCreateCredentialResponse = (
  dto: CreateClientResponseDTO,
): CreateCredentialResponse => ({
  clientId: dto.client_id,
  clientSecret: dto.client_secret,
  name: dto.name,
  createdAt: dto.created_at,
});

export const toRotateSecretResponse = (
  dto: RotateSecretResponseDTO,
): RotateSecretResponse => ({
  clientId: dto.client_id,
  clientSecret: dto.client_secret,
  rotatedAt: dto.rotated_at,
});

export const toCountryOptions = (
  countries: string[],
): { label: string; value: string }[] =>
  countries.map(country => ({
    label: country,
    value: country,
  }));
